import Joi from "joi";
const vuetifyConfig = (state, focused, defaultHideDetailsState = "auto") => {
  const ret = {
    props: {
      "error-messages": state.touched ? state.errors.filter(
        (v) => typeof v === "string" && v.trim().length > 0
      ) : [],
      "hide-details": !state.touched || focused || state.errors.filter(
        (v) => typeof v === "string" && v.trim().length > 0
      ).length === 0 ? true : defaultHideDetailsState
    }
  };
  return ret;
};
const vuetifyOtpConfig = (state, focused) => ({
  props: {
    error: state.touched && state.errors.length > 0 && "boolean" === typeof focused && focused !== true
  }
});
const _forms = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  vuetifyConfig,
  vuetifyOtpConfig
}, Symbol.toStringTag, { value: "Module" }));
const getTranslatedErrorMessage = (error, t, label) => {
  if (0 === error.details.length) {
    return error.message;
  }
  if (!error.details[0].context) {
    error.details[0].context = { label };
  }
  error.details[0].context.label = label.trim();
  const { context, type } = error.details[0];
  const i18nKey = `validation.${type}`;
  return t(i18nKey, context);
};
function getJoiValidationErrorI18n(error, t, label = "the Field") {
  if (!error) {
    return "";
  }
  if (!(error instanceof Joi.ValidationError)) {
    return error.message;
  }
  return getTranslatedErrorMessage(error, t, label);
}
const doSchemaValidation = (t, schema, value, label) => {
  const { error } = schema.validate(value);
  if (error instanceof Joi.ValidationError) {
    return getJoiValidationErrorI18n(error, t, label);
  }
  return true;
};
const doVeeValidateValidation = (t, schema, value, meta, label) => {
  if ("string" !== typeof label) {
    label = meta.label || meta.name;
  }
  return doSchemaValidation(t, schema, value, label);
};
const getFormFieldValidator = (t, schema, label) => {
  return (value, meta) => doVeeValidateValidation(t, schema, value, meta, label);
};
const _validators = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  doSchemaValidation,
  doVeeValidateValidation,
  getFormFieldValidator,
  getJoiValidationErrorI18n
}, Symbol.toStringTag, { value: "Module" }));
export {
  _forms as _,
  _validators as a,
  vuetifyOtpConfig as b,
  getFormFieldValidator as g,
  vuetifyConfig as v
};
//# sourceMappingURL=_validators-f968e1a2.mjs.map
